<template>
    <div class="section-posts2 section-posts-feed">
        <div class="navigations">
            <div class="container-list-avatar">
                <div class="list-avatar hide-scrollbar">
                    <Avatar 
                        v-for="page in pagesSelected" 
                        :urlPicture="page.avatar" 
                        :typeNetwork="page.network" 
                        :key="page.id"
                        :checked="pageSelected && page.id == pageSelected.id"
                        @click="()=> selectPage(page)"
                    />
                </div>
            </div>
          
            <MainNavigation v-on="$listeners" :tabSelected="tabSelected"/>
        </div>
        <div class="content">
            <ListPosts 
                v-if="pageSelected && Object.keys(groupedItems).length" 
                :groups="groupedItems" 
                @selectEvent="handleEventClick"
                @changeDate="changeDate"
            />
            <PostNotFound v-else />
            <div class="instagram-app">
                <div class="container-phone">
                    <div class="actions">
                        <div class="container-legend">
                            <div class="legend">
                                <div class="item" v-for="status in ['scheduled', 'draft', 'posted']">
                                    <div class="circle-status card-status-background-primary-color" :class="status"></div>
                                    <p class="card-status-color" :class="status">{{$t(`dash.post.${status}`)}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="btns">
                            <div class="btn" @click="refreshInstagramData">
                                <i class="fa-solid fa-rotate"></i>
                            </div>
                            <div class="btn">
                                <i class="fa-solid fa-moon"></i>
                            </div>
                            <div class="btn">
                                <i class="fa-solid fa-download"></i>
                            </div>
                        </div>
                    </div>
                   
                    <Phone>
                        <InstagramInterface 
                            :plannedItems="plannedItems" 
                            :postedItems="postedItems" 
                            :pinnedItems="pinnedItems" 
                            :statsProfile="statsProfile"
                            :page="pageSelected"
                            :loadingCard="this.configFetchItemPosted.isLoading || !this.configFetchItemPosted.isEnd"
                            @changeDate="changeDate"
                            @loadMorePostedItems="fetchItemPosted"
                            
                        />
                    </Phone>
                </div>
            </div>
        </div>

        <DrawerPost 
            v-if="eventSelected" 
            :event="eventSelected"
            @close="closeDrawer"
            @deletePost="handlerDeletePost"
        />
    </div>
</template>

<script>
import MainNavigation from './components/MainNavigation.vue'
import Phone from "./../postCreator/components/Phone.vue"
import Avatar from '../utils/avatar.vue';
import InstagramInterface from "./components/feed/InstagramInterface.vue"
import ListPosts from"./components/feed/ListPosts.vue"
import PostNotFound from "./components/feed/PostNotFound.vue"
import postMixins from '@/components/mixins/Posts.vue'
import DrawerPost from './components/DrawerPost.vue'
import sectionPostMixins from './mixins/main.js'
import { event } from 'vue-analytics';
import { convertOldDraft, patchDraft } from './utils/draft.js';

export default {
    
    components: {
        MainNavigation,
        Avatar,
        Phone,
        InstagramInterface,
        ListPosts,
        PostNotFound,
        DrawerPost
    },

    mixins: [postMixins, sectionPostMixins],

    props: {
        tabSelected: String
    },

    data() {
        return {
            pageSelected: null,

            plannedItems: [
                // { name: "John 1", id: 0, date: "2025-03-28T15:08:57.701Z", url: "https://picsum.photos/701", status : 'scheduled'},
                // { name: "Joao 2", id: 1, date: "2025-03-27T14:08:57.701Z", url: "https://picsum.photos/702", status : 'scheduled'},
                // { name: "Jean 3", id: 2, date: "2025-03-28T14:08:57.701Z", url: "https://picsum.photos/703", status : 'draft'},
                // { name: "Jonny 4", id: 3, date: "2025-03-28T11:08:57.701Z", url: "https://picsum.photos/704", status : 'draft'}, 
                // { name: "Guisepe 5", id: 4, date: "2025-03-27T14:08:57.701Z", url: "https://picsum.photos/705", status : 'draft'},
              
            ],

            postedItems: [
                // { name: "Hello 6", id: 5, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/706", status : 'posted'},
                // { name: "dism 7", id: 6, date: "2025-03-21T11:08:57.701Z", url: "https://picsum.photos/707", status : 'posted'},
                // { name: "Hello 6", id: 7, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/708", status : 'posted'},
                // { name: "dism 7", id: 8, date: "2025-03-21T11:08:57.701Z", url: "https://picsum.photos/709", status : 'posted'},
                // { name: "Hello 6", id: 9, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/710", status : 'posted'},
                // { name: "dism 7", id: 10, date: "2025-03-21T11:08:57.701Z", url: "https://picsum.photos/711", status : 'posted'},
                // { name: "Hello 6", id: 11, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/712", status : 'posted'},
                // { name: "dism 7", id: 12, date: "2025-03-21T11:08:57.701Z", url: "https://picsum.photos/713", status : 'posted'},
            ],

            pinnedItems: [
                { name: "Hello 6", id: 13, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/714", status : 'posted'},
            ],

            groupedItems: {}, // Objets regroupés par date
            mergedList: [],

            statsProfile: {
                followers_count: 0,
                follows_count: 0,
                media_count: 0,
            },

            configFetchItemPosted: {
                currentDate: null,
                isEnd: false,
                isLoading: false
            },
            eventSelected : null,
        }
    },

    mounted () {
        this.pageSelected = this.pagesSelected[0]
        if (this.pageSelected){
            this.fetchData()
        }
    },
    methods: {
        async fetchData() {
            //recuperation des items posté
            this.postedItems = []
            this.pinnedItems = []
            this.plannedItems = []
            this.syncGroupedItems();

            if (!this.pageSelected) return
            const date = new Date();
            let currentStart = date.toISOString();
            date.setMonth(date.getMonth() + 12);
            let currentEnd = date.toISOString()

            const {body} = await this.postsByPages(
                this.pageSelected.id, 
                1000,
                currentStart,
                currentEnd,
                false,
                false,
                false
            )
           
            for (const post of body.posts) {
            
                const status = post.page && post.page.length ? ['removed', null, 'scheduled', 'posted', 'pending', 'failed', null, 'draft'][post.page[0].status + 1] : 'standby'

                if (['scheduled','draft'].includes(status) && (!post.page[0] || !post.page[0].story) && post.enclosure) {
            
                    const event = await this.buildEvent(post);
                    this.plannedItems.push({
                        ...event,
                        name: post.title, 
                        content: post.title, 
                        id: post.id,
                        date: event.date,
                        url: post.enclosure, 
                        status : status,
                        format_date: new Date(event.date).toLocaleString('fr-FR', {hour: '2-digit', minute: '2-digit' }).replace(',', ' à')
                    })
                }
                
            }

            this.sortItems()
            this.syncGroupedItems();

      
       
            
            try {
                this.statsProfile= {
                    followers_count:0,
                    follows_count:0,
                    media_count:0
                }

                this.configFetchItemPosted= {
                    currentDate: null,
                    isEnd: false,
                    isLoading: false
                }

                const {body} = await this.getInstagramPageStatsProfile(this.pageSelected.id)
                
                if (body.success) {
                    this.statsProfile = {
                        followers_count: body.followers_count,
                        follows_count: body.follows_count,
                        media_count: body.media_count,
                    }
                    

                    const currentDate = new Date();
                    currentDate.setDate(1);

                    this.configFetchItemPosted = {
                        currentDate: currentDate,
                        isEnd: false,
                        isLoading: false
                    }

                
                    this.fetchItemPosted()
                    console.log('posts', this.postedItems, currentDate)
                }
                
            } catch (error) {
                
            }
            console.log('body',body)
        },

        async fetchItemPosted() {
            if (this.configFetchItemPosted.isLoading || this.configFetchItemPosted.isEnd) return
            const pageIdSelected = this.pageSelected.id
            this.configFetchItemPosted.isLoading = true
            let twoYearsAgo = new Date();
            twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);
            const posts = []

            while (pageIdSelected == this.pageSelected.id && posts.length < 9 && this.configFetchItemPosted.currentDate >= twoYearsAgo && this.postedItems.length + posts.length < this.statsProfile.media_count) {
                let startOfMonth = new Date(this.configFetchItemPosted.currentDate.getFullYear(), this.configFetchItemPosted.currentDate.getMonth(), 1);
                let endOfMonth = new Date(this.configFetchItemPosted.currentDate.getFullYear(), this.configFetchItemPosted.currentDate.getMonth() + 1, 1);
                
                let startTimestamp = Math.floor(startOfMonth.getTime() / 1000);
                let endTimestamp = Math.floor(endOfMonth.getTime() / 1000);
                console.log({startOfMonth,endOfMonth,startTimestamp,endTimestamp})
                try {
                    const { body } = await this.getPostsFromRS(pageIdSelected, startTimestamp, endTimestamp);
                    if (body.success && body.posts && body.posts.data.length > 0) {
                        
                        posts.push(...body.posts.data.map(post => (
                            { 
                                name: post.caption, 
                                id: post.id, 
                                date: post.timestamp, 
                                url: post.full_picture,
                                status : 'posted',
                                type: {CAROUSEL_ALBUM: 'carousel', IMAGE : '', VIDEO: 'reel'}[post.media_type]
                            }
                        )));
                    }
                } catch (error) {
                    console.error("Error fetching posts: ", error);
                    break;
                }
                        
                this.configFetchItemPosted.currentDate.setMonth(this.configFetchItemPosted.currentDate.getMonth() - 1);
            }

            if (pageIdSelected !== this.pageSelected.id) {
                return
            }

            if (this.configFetchItemPosted.currentDate < twoYearsAgo || this.postedItems.length + posts.length >= this.statsProfile.media_count) {
                this.configFetchItemPosted.isEnd = true
            }
  
            this.postedItems = [...this.postedItems,...posts]
            this.configFetchItemPosted.isLoading = false
        },

        async refreshInstagramData() {
            this.configFetchItemPosted= {
                currentDate: null,
                isEnd: false,
                isLoading: false
            }
            this.postedItems = []

            const {body} = await this.getInstagramPageStatsProfile(this.pageSelected.id)
            
            if (body.success) {
                this.statsProfile = {
                    followers_count: body.followers_count,
                    follows_count: body.follows_count,
                    media_count: body.media_count,
                }
                

                const currentDate = new Date();
                currentDate.setDate(1);

                this.configFetchItemPosted = {
                    currentDate: currentDate,
                    isEnd: false,
                    isLoading: false
                }

                this.fetchItemPosted()
                console.log('posts', this.postedItems, currentDate)
            }
        },

        selectPage(page) {
            this.pageSelected = page
            this.fetchData()
        },

        async changeDate({postId, newDate, itemsSort, refreshGroupedItems = true}) {
            console.log("changeDate", {postId, newDate, itemsSort, refreshGroupedItems})
            if (itemsSort) {
                this.plannedItems = itemsSort
            }else{
                const indexPost = this.plannedItems.findIndex(item => item.id == postId)
                if (indexPost) {
                    this.plannedItems[indexPost].date = newDate
                    this.sortItems()
                }
            }

            if (refreshGroupedItems) {
                this.syncGroupedItems()
            }

            const event = this.plannedItems.find(item => item.id == postId)
            if (event) {
                this.$set(event, 'format_date', new Date(event.date).toLocaleString('fr-FR', {hour: '2-digit', minute: '2-digit' }).replace(',', ' à'))
                
                if (event.originalPost) {
                    const dateInstance = new Date(newDate)
                    const {body} = await this.updatePostScheduledDate(event.originalPost, {
                        date: newDate,
                        hour: dateInstance.getHours(), 
                        minute: dateInstance.getMinutes(), 
                        scheduledDate: newDate,
                    }, false, false)
                }
             
            }
        },

        sortItems() {
            this.plannedItems.sort((a, b) => new Date(b.date) - new Date(a.date));
        },

        syncGroupedItems(sortItems = false) {
            if (sortItems) this.sortItems()
            this.groupedItems = {}
            this.plannedItems.forEach(item => {
                const date = item.date.split('T')[0]
                if (!this.groupedItems[date]) this.groupedItems[date] = []
                this.groupedItems[date].push(item)
            });

            //trier chaque group par date
            // Object.keys(this.groupedItems).forEach(date => {
            //     this.groupedItems[date].sort((a, b) => new Date(a.date) - new Date(b.date));
            // });
           
        },

        syncMergeList() {

        },

         async handleEventClick(event) {
          
            if (event.draft && !event.draft.saveAllFormData) {

                const pages =  event.originalPost.page && event.originalPost.page[0].posts_multipages ? 
                    event.originalPost.page[0].posts_multipages.map(({page}) => page) : 
                    [event.page.id]

                const draft = patchDraft(await convertOldDraft(JSON.parse(JSON.stringify(event.draft)), pages))
                
                event.draft = draft                
            }
            this.eventSelected = event
        },
        
        closeDrawer() {
            this.eventSelected = null
        },
    },

    watch: {
        pagesSelected: {
            immediate: true,
            handler(newValue, oldValue) {
                if (!newValue.length) {
                    this.$emit('changeTab','planner')
                }
            }
        }
    },

    computed: {

        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].filter(page => page.network == 'instagram');
        },

        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
    }
} 
</script>